import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IWatch } from 'Domain';

interface WatchState {
  watches: IWatch[];
  selectedWatch: IWatch | null;
  loading: boolean;
  error: string | null;
  filters: {
    brand?: string;
    minPrice?: number;
    maxPrice?: number;
  };
}

const initialState: WatchState = {
  watches: [],
  selectedWatch: null,
  loading: false,
  error: null,
  filters: {},
};

const watchSlice = createSlice({
  name: 'watch',
  initialState,
  reducers: {
    // Fetch watches
    fetchWatchesRequest: (state, action: PayloadAction<any>) => {
      state.loading = true;
      state.error = null;
      state.filters = action.payload || {};
    },
    fetchWatchesSuccess: (state, action: PayloadAction<IWatch[]>) => {
      state.watches = action.payload;
      state.loading = false;
    },
    fetchWatchesFailure: (state, action: PayloadAction<string>) => {
      state.error = action.payload;
      state.loading = false;
    },

    // Fetch single watch by slug
    fetchWatchBySlugRequest: (state, action: PayloadAction<string>) => {
      state.loading = true;
      state.error = null;
    },
    fetchWatchBySlugSuccess: (state, action: PayloadAction<IWatch>) => {
      state.selectedWatch = action.payload;
      state.loading = false;
    },
    fetchWatchBySlugFailure: (state, action: PayloadAction<string>) => {
      state.error = action.payload;
      state.loading = false;
    },

    // Clear selected watch
    clearSelectedWatch: (state) => {
      state.selectedWatch = null;
    },
  },
});

export const {
  fetchWatchesRequest,
  fetchWatchesSuccess,
  fetchWatchesFailure,
  fetchWatchBySlugRequest,
  fetchWatchBySlugSuccess,
  fetchWatchBySlugFailure,
  clearSelectedWatch,
} = watchSlice.actions;

export default watchSlice.reducer;
